"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = exports.AccountActionTypes = void 0;
var common_impl_1 = require("./common-impl");
var common_types_1 = require("./common-types");
var configs_1 = require("../configs");
var auth = require("../authProvider");
var Configs = require("../configs");
// -----------------
// STATE - This defines the type of data maintained in the Redux store.
var AccountActionTypes;
(function (AccountActionTypes) {
    AccountActionTypes["ACCOUNT_SUBMIT_STARTED"] = "ACCOUNT_SUBMIT_STARTED";
    AccountActionTypes["ACCOUNT_SUBMIT_SUCCEEDED"] = "ACCOUNT_SUBMIT_SUCCEEDED";
    AccountActionTypes["ACCOUNT_SUBMIT_FAILED"] = "ACCOUNT_SUBMIT_FAILED";
    AccountActionTypes["ACCOUNT_UPDATE_REMAINING_SENDS"] = "ACCOUNT_UPDATE_REMAINING_SENDS";
    AccountActionTypes["ACCOUNT_QUERY_STARTED"] = "ACCOUNT_QUERY_STARTED";
    AccountActionTypes["ACCOUNT_QUERY_SUCCEEDED"] = "ACCOUNT_QUERY_SUCCEEDED";
    AccountActionTypes["ACCOUNT_QUERY_FAILED"] = "ACCOUNT_QUERY_FAILED";
    AccountActionTypes["SUBSCRIPTION_CANCEL_REQUEST_STARTED"] = "SUBSCRIPTION_CANCEL_REQUEST_STARTED";
    AccountActionTypes["SUBSCRIPTION_CANCEL_REQUEST_SUCCEEDED"] = "SUBSCRIPTION_CANCEL_REQUEST_SUCCEEDED";
    AccountActionTypes["SUBSCRIPTION_CANCEL_REQUEST_FAILED"] = "SUBSCRIPTION_CANCEL_REQUEST_FAILED";
    AccountActionTypes["RESET_CANCEL_SUBSCRIPTION_FLAG"] = "RESET_CANCEL_SUBSCRIPTION_FLAG";
    AccountActionTypes["SUBSCRIPTION_CANCEL_FAIL"] = "SUBSCRIPTION_CANCEL_FAIL";
})(AccountActionTypes = exports.AccountActionTypes || (exports.AccountActionTypes = {}));
// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).
exports.actionCreators = {
    setSubscriptionCancelError: function () { return function (dispatch, getState) {
        dispatch({
            type: AccountActionTypes.SUBSCRIPTION_CANCEL_FAIL, error: "Failed to cancel your subscription. Please contact support at <a href='maito:" + Configs.TRIBELY_SUPPORT_EMAIL + "'>" + Configs.TRIBELY_SUPPORT_EMAIL + "</a>"
        });
    }; },
    getAccount: function (accountNumber) {
        if (accountNumber === void 0) { accountNumber = null; }
        return function (dispatch, getState) {
            var _a, _b;
            var account = buildAccount(getState());
            // Set the account number if passed in
            if (accountNumber) {
                account.accountNumber = accountNumber.toUpperCase();
            }
            var accountApiSubmitEnvelope = {
                id: account.id,
                tenantId: account.tenantId,
                type: common_types_1.ApiSubmitTypes.ACCOUNT,
                userId: account.id,
                account: account
            };
            dispatch({ type: AccountActionTypes.ACCOUNT_QUERY_STARTED });
            if (account.accountNumber !== undefined) {
                fetch(configs_1.BASE_API_URI + "/accounts/" + ((_a = getState().account) === null || _a === void 0 ? void 0 : _a.accountEntity.id) + "?tenantId=" + ((_b = getState().account) === null || _b === void 0 ? void 0 : _b.accountEntity.tenantId), {
                    'headers': {
                        'x-api-key': Configs.QUERY_API_KEY,
                        'Content-Type': 'application/json'
                    },
                    'method': 'GET'
                })
                    .then(common_impl_1.handleErrors)
                    .then(function (response) { return response.json(); })
                    .then(function (responseData) {
                    dispatch({ type: AccountActionTypes.ACCOUNT_QUERY_SUCCEEDED, account: responseData });
                })
                    .catch(function (error) {
                    if (error.text) {
                        error.text().then(function (errorText) {
                            return dispatch({
                                type: AccountActionTypes.ACCOUNT_QUERY_FAILED, error: errorText
                            });
                        });
                    }
                    else {
                        dispatch({
                            type: AccountActionTypes.ACCOUNT_QUERY_FAILED, error: configs_1.ERROR_GENERIC_MESSAGE
                        });
                    }
                });
            }
        };
    },
    cancelSubscription: function () { return function (dispatch, getState) {
        var _a;
        var state = getState();
        var subscriptionCancellationRequest = {
            id: (_a = state.account) === null || _a === void 0 ? void 0 : _a.accountEntity.id,
            type: 'cancelSubscription',
            tenantId: auth.getTenantId(),
            userId: auth.getUserId()
        };
        dispatch({ type: AccountActionTypes.SUBSCRIPTION_CANCEL_REQUEST_STARTED });
        fetch(configs_1.BASE_API_URI + "/accounts", {
            'headers': {
                'x-api-key': configs_1.WRITE_API_KEY,
                'Content-Type': 'application/json'
            },
            'method': 'POST',
            'body': JSON.stringify(subscriptionCancellationRequest)
        })
            .then(common_impl_1.handleErrors)
            .then(function (response) { return response.text(); })
            .then(function (response) {
            dispatch({ type: AccountActionTypes.SUBSCRIPTION_CANCEL_REQUEST_SUCCEEDED });
        })
            .catch(function (error) {
            if (error.text) {
                error.text().then(function (errorText) {
                    dispatch({
                        type: AccountActionTypes.SUBSCRIPTION_CANCEL_REQUEST_FAILED, error: errorText
                    });
                });
            }
            else {
                dispatch({
                    type: AccountActionTypes.SUBSCRIPTION_CANCEL_REQUEST_FAILED, error: configs_1.ERROR_GENERIC_MESSAGE
                });
            }
        });
    }; },
    submitAccount: function (accountNumber) {
        if (accountNumber === void 0) { accountNumber = null; }
        return function (dispatch, getState) {
            var account = buildAccount(getState());
            // Set the account number if passed in
            if (accountNumber) {
                account.accountNumber = accountNumber.toUpperCase();
            }
            var accountApiSubmitEnvelope = {
                id: account.id,
                tenantId: account.tenantId,
                type: common_types_1.ApiSubmitTypes.ACCOUNT,
                userId: account.id,
                account: account
            };
            dispatch({ type: AccountActionTypes.ACCOUNT_SUBMIT_STARTED });
            fetch(configs_1.BASE_API_URI + "/accounts", {
                'headers': {
                    'x-api-key': configs_1.WRITE_API_KEY,
                    'Content-Type': 'application/json'
                },
                'method': 'POST',
                'body': JSON.stringify(accountApiSubmitEnvelope)
            })
                .then(common_impl_1.handleErrors)
                .then(function (response) { return response.json(); })
                .then(function (responseData) {
                dispatch({ type: AccountActionTypes.ACCOUNT_SUBMIT_SUCCEEDED, account: responseData });
            })
                .catch(function (error) {
                if (error.text) {
                    error.text().then(function (errorText) {
                        return dispatch({
                            type: AccountActionTypes.ACCOUNT_SUBMIT_FAILED, error: errorText
                        });
                    });
                }
                else {
                    dispatch({
                        type: AccountActionTypes.ACCOUNT_SUBMIT_FAILED, error: configs_1.ERROR_GENERIC_MESSAGE
                    });
                }
            });
        };
    },
    resetSubscriptionCancelledFlag: function () { return function (dispatch, getState) {
        dispatch({ type: AccountActionTypes.RESET_CANCEL_SUBSCRIPTION_FLAG, error: null });
    }; }
};
var buildAccount = function (state) {
    var _a, _b, _c, _d, _e;
    return ({
        id: auth.getUserId(),
        idpIssuer: auth.getIssuer(),
        objectId: auth.getObjectId(),
        tenantId: auth.getTenantId(),
        dateCreated: '',
        userCity: auth.getCity(),
        userCountry: auth.getCountry(),
        userDisplayName: auth.getDisplayName(),
        userEmail: auth.getEmail(),
        userFirstName: auth.getFirstName(),
        userLastName: auth.getLastName(),
        clientVersion: Configs.APP_VERSION,
        lastClientCommandMessageId: common_impl_1.getLastClientCommandMessageId(),
        isNewUser: !auth.isNewUser() ? false : true,
        billingEmail: (_a = state.account) === null || _a === void 0 ? void 0 : _a.accountEntity.billingEmail,
        subscriptionName: (_b = state.account) === null || _b === void 0 ? void 0 : _b.accountEntity.subscriptionName,
        subscriptionStatus: (_c = state.account) === null || _c === void 0 ? void 0 : _c.accountEntity.subscriptionStatus,
        accountNumber: (_d = state.account) === null || _d === void 0 ? void 0 : _d.accountEntity.accountNumber,
        validUntil: (_e = state.account) === null || _e === void 0 ? void 0 : _e.accountEntity.validUntil
    });
};
// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
var unloadedState = {
    isLoading: false,
    error: null,
    didCancelSubscriptionRequested: false,
    accountEntity: {}
};
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case AccountActionTypes.ACCOUNT_SUBMIT_STARTED:
            return {
                isLoading: true,
                accountEntity: state.accountEntity,
                didCancelSubscriptionRequested: false,
                error: null
            };
        case AccountActionTypes.ACCOUNT_SUBMIT_SUCCEEDED:
            return {
                isLoading: false,
                accountEntity: action.account,
                error: null
            };
        case AccountActionTypes.ACCOUNT_SUBMIT_FAILED:
            return {
                isLoading: false,
                accountEntity: state.accountEntity,
                error: action.error
            };
        case AccountActionTypes.ACCOUNT_QUERY_STARTED:
            return {
                isLoading: true,
                accountEntity: state.accountEntity,
                error: null
            };
        case AccountActionTypes.ACCOUNT_QUERY_SUCCEEDED:
            return {
                isLoading: false,
                accountEntity: action.account,
                error: null
            };
        case AccountActionTypes.ACCOUNT_QUERY_FAILED:
            return {
                isLoading: false,
                accountEntity: state.accountEntity,
                error: action.error
            };
        case AccountActionTypes.ACCOUNT_UPDATE_REMAINING_SENDS:
            return {
                isLoading: false,
                accountEntity: __assign(__assign({}, state.accountEntity), { remainingSends: action.remainingSends }),
                error: null
            };
        case AccountActionTypes.SUBSCRIPTION_CANCEL_REQUEST_STARTED:
            return {
                isLoading: true,
                accountEntity: state.accountEntity,
                didCancelSubscriptionRequested: false,
                error: null
            };
        case AccountActionTypes.SUBSCRIPTION_CANCEL_REQUEST_SUCCEEDED:
            return {
                isLoading: false,
                accountEntity: state.accountEntity,
                didCancelSubscriptionRequested: true,
                error: null
            };
        case AccountActionTypes.SUBSCRIPTION_CANCEL_REQUEST_FAILED:
            return {
                isLoading: false,
                accountEntity: state.accountEntity,
                didCancelSubscriptionRequested: false,
                error: action.error
            };
        case AccountActionTypes.RESET_CANCEL_SUBSCRIPTION_FLAG:
            return {
                isLoading: false,
                accountEntity: state.accountEntity,
                didCancelSubscriptionRequested: false,
                error: null
            };
        case AccountActionTypes.SUBSCRIPTION_CANCEL_FAIL:
            return {
                isLoading: false,
                accountEntity: state.accountEntity,
                error: action.error
            };
        default:
            return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=account.store.js.map